import { getUserFirstComment } from "@/services/UserService";

interface Property {
    id: string;
    full_address: string;
    [key: string]: any;
}

interface GetShareTextForPropertyParams {
    userId: string;
    property: Property;
}

/**
 * Returns the share text for a property.
 * If the user has a first-level comment, use it; otherwise, use the address.
 * @param params - Object containing userId and property
 * @returns Promise that resolves to the share text
 */
export async function getShareTextForProperty({ userId, property }: GetShareTextForPropertyParams): Promise<string> {
    let shareTextBody = property?.full_address;
    try {
        if (userId && property?.id) {
            const firstCommentRes = await getUserFirstComment(userId, "Property", property.id);
            const commentContent = firstCommentRes?.comment?.content;
            if (typeof commentContent === "string" && commentContent.trim().length > 0) {
                shareTextBody = commentContent.trim();
            }
        }
    } catch (e) {
        // fallback to address if error
        shareTextBody = property?.full_address;
    }
    return shareTextBody;
}
